import { Component, OnInit } from '@angular/core';
import { EnvState } from 'app/modules/shared/helpers/env-state';

@Component({
    selector: 'app-footerinfo',
    templateUrl: './footerinfo.component.html',
    styleUrls: ['./footerinfo.component.scss'],
    standalone: false
})
export class FooterinfoComponent implements OnInit {
  year = new Date().getFullYear();

  constructor(public env: EnvState) {}

  ngOnInit(): void {}
}
